<p-fieldset legend="Estimates" [toggleable]="true">
    <p-editor [style]="{'height':'100px'}" [(ngModel)]="estimateTermText" class="custom-editor-width">
        <ng-template pTemplate="header">
            <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-underline" aria-label="Underline"></button>
                <span class="ql-formats">
                    <button type="button" class="ql-list" aria-label="List" value='ordered'></button>
                    <button type="button" class="ql-list" aria-label="Bullet" value='bullet'></button>
                    <select class="ql-align">
                        <option selected>Gauche</option>
                        <option value="center" aria-label="Center"></option>
                        <option value="right" aria-label="Right"></option>
                        <option value="justify" aria-label="Justify"></option>
                    </select>
                </span>
            </span>
        </ng-template>
    </p-editor>
    <div class="btn-container">
        <button pButton type="button" (click)="saveEstimateTermsConditions()" label="Save"></button>
    </div>
</p-fieldset>
<p-fieldset legend="Sales Orders" [toggleable]="true">
    <p-editor [style]="{'height':'100px'}" [(ngModel)]="soTermText" class="custom-editor-width">
        <ng-template pTemplate="header">
            <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-underline" aria-label="Underline"></button>
                <span class="ql-formats">
                    <button type="button" class="ql-list" aria-label="List" value='ordered'></button>
                    <button type="button" class="ql-list" aria-label="Bullet" value='bullet'></button>
                    <select class="ql-align">
                        <option selected>Gauche</option>
                        <option value="center" aria-label="Center"></option>
                        <option value="right" aria-label="Right"></option>
                        <option value="justify" aria-label="Justify"></option>
                    </select>
                </span>
            </span>
        </ng-template>
    </p-editor>
    <div class="btn-container">
        <button pButton type="button" (click)="saveSalesOrderTermsConditions()" label="Save" class="p-mr-2"></button>
    </div>
</p-fieldset>
<p-fieldset legend="Invoices" [toggleable]="true">
    <p-editor [style]="{'height':'100px'}" [(ngModel)]="invoiceTermText" class="custom-editor-width">
        <ng-template pTemplate="header">
            <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-underline" aria-label="Underline"></button>
                <span class="ql-formats">
                    <button type="button" class="ql-list" aria-label="List" value='ordered'></button>
                    <button type="button" class="ql-list" aria-label="Bullet" value='bullet'></button>
                    <select class="ql-align">
                        <option selected>Gauche</option>
                        <option value="center" aria-label="Center"></option>
                        <option value="right" aria-label="Right"></option>
                        <option value="justify" aria-label="Justify"></option>
                    </select>
                </span>
            </span>
        </ng-template>
    </p-editor>
    <div class="btn-container">
        <button pButton type="button" (click)="saveInvoiceTermsConditions()" label="Save" class="p-mr-2"></button>
    </div>
</p-fieldset>
<p-fieldset legend="Credit Memo" [toggleable]="true">
    <p-editor [style]="{'height':'100px'}" [(ngModel)]="creditMemoTermText" class="custom-editor-width">
        <ng-template pTemplate="header">
            <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-underline" aria-label="Underline"></button>
                <span class="ql-formats">
                    <button type="button" class="ql-list" aria-label="List" value='ordered'></button>
                    <button type="button" class="ql-list" aria-label="Bullet" value='bullet'></button>
                    <select class="ql-align">
                        <option selected>Gauche</option>
                        <option value="center" aria-label="Center"></option>
                        <option value="right" aria-label="Right"></option>
                        <option value="justify" aria-label="Justify"></option>
                    </select>
                </span>
            </span>
        </ng-template>
    </p-editor>
    <div class="btn-container">
        <button pButton type="button" (click)="saveCreditMemoTermsConditions()" label="Save" class="p-mr-2"></button>
    </div>
</p-fieldset>
<!-- <p-fieldset legend="Customer RMA" [toggleable]="true">
    <p-editor [style]="{'height':'100px'}">
        <ng-template pTemplate="header">
            <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-underline" aria-label="Underline"></button>
                <span class="ql-formats">
                    <button type="button" class="ql-list" aria-label="List" value='ordered'></button>
                    <button type="button" class="ql-list" aria-label="Bullet" value='bullet'></button>
                    <select class="ql-align">
                        <option selected>Gauche</option>
                        <option value="center" aria-label="Center"></option>
                        <option value="right" aria-label="Right"></option>
                        <option value="justify" aria-label="Justify"></option>
                    </select>
                </span>
            </span>
        </ng-template>
    </p-editor>
</p-fieldset> -->